import styled from 'styled-components';

export const ActionButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
`;
